module.exports = __webpack_public_path__ + "img/logo.442dcc7e.svg";